import { AnimatePresence } from 'framer-motion';
import React, { useState, useEffect } from 'react';
import Preloader from '../preloader';
import Header from '../header';
import Footer from '../footer/one/footer';
import { Outlet } from 'react-router-dom';

function LayoutOne() {
    const [isLoading, setIsLoading] = useState(true);
    const words = ["SeLaMaT DaTANg", "hEllO", "BonJOuR", "Ciao", "HoLA", "HAllO"];

    useEffect(() => {
        let locomotiveScroll;

        (
            async () => {
                const LocomotiveScroll = (await import('locomotive-scroll')).default;
                locomotiveScroll = new LocomotiveScroll();

                setTimeout(() => {
                    setIsLoading(false);
                    window.scrollTo(0, 0);
                }, 2000);
            }
        )();

        return () => {
            if (locomotiveScroll) {
                locomotiveScroll.destroy();
            }
        };
    }, []);

    return (
        <>
            <AnimatePresence mode='wait'>
                {isLoading && <Preloader words={words} />}
            </AnimatePresence>
            <>
                <Header titleClass={false} />
                <Outlet />
                <hr className="border-lemone md:border-4" />
                <Footer />
            </>
        </>
    );
}

export default LayoutOne;